// 非代码生成的store，在这里手动导入，再从这里导入到index-em-stores
// auth YuJiaBei
// Date 2020-02-28 16:50

import inspectionRecordForInspection from "@/store/em/inspection/InspectionRecordForInspectionStore.js";
import repairWorkOrderExecute from "@/store/em/repair/RepairWorkOrderExecuteStore.js";

const genericEntities = [
    'inspectionRecordForInspection',
    'repairWorkOrderExecute'
]

const entities = {
    inspectionRecordForInspection,
    repairWorkOrderExecute
}

export {genericEntities}

export default entities